import './home.scss'
import React, { useState, useRef } from 'react'
import api_host from '../../env'

const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@?#$%^])[A-Za-z\d!@?#$%^]{10,32}$/

const UpdatePassword = ({ searchedAccountID, history }) => {
  const passwordRef = useRef(null)
  const confirmPasswordRef = useRef(null)
  const [passwordInput, setPasswordInput] = useState('')
  const [confirmPwdInput, setConfirmPwdInput] = useState('')
  const [isPasswordValid, setIsPasswordValid] = useState(true)

  const handlePwdInput = ({ currentTarget }) =>
    setPasswordInput(currentTarget.value)
  const handleConfirmPwdInput = ({ currentTarget }) =>
    setConfirmPwdInput(currentTarget.value)

  const [updatePwdError, setUpdatePwdError] = useState(null)

  const isUpdatePwdBtnEnabled = () =>
    passwordInput.length > 0 && confirmPwdInput.length > 0

  const handleUpdatePwd = () => {
    const isInvalid = !regex.test(passwordInput)
    if (!sessionStorage.getItem('token')) {
      setUpdatePwdError('User not logged in')
      return
    }
    if (passwordInput !== confirmPwdInput) {
      setUpdatePwdError('Failed -  Passwords didn\'t match')
      return
    }
    // Password Validation
    if(isInvalid) 
    {
      setUpdatePwdError('Password must be 10–32 characters long, contains an uppercase, a lowercase, a number, and allowed symbol (!@?#$%^).')
      return
    }
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        token: sessionStorage.getItem('token')
      },
      body: JSON.stringify({
        password: passwordInput
      })
    }
    // update password API call
    fetch(`${api_host}/accounts/${searchedAccountID}/resetPassword`, config)
      .then(res => res.json())
      .then(data => {
        if (data && ((data.message && data.message.indexOf('Failed - Invalid Token') > -1) || (data.error && data.error.indexOf('Failed - Invalid SessionGUID') > -1))) {
          sessionStorage.removeItem('token')
          history.push('/signin')
        } else if (data && data.error && Array.isArray(data.error)) {
          setUpdatePwdError(data.error.join('\n'))
        } else if (data && data.error && !Array.isArray(data.error)) {
          setUpdatePwdError(data.error)
        } else if (data && data.description) {
          setUpdatePwdError('Password Reset Successful!')
          setPasswordInput('')
          setConfirmPwdInput('')
          passwordRef.current.value = ''
          confirmPasswordRef.current.value = ''
        } else {
          setUpdatePwdError('Something went wrong')
        }
      })
      .catch(() => setUpdatePwdError('Something went wrong'))
  }
  return (
    <>
      <div className="change-pwd-div">
        <label htmlFor="password" class="login-label">New Password</label>
        <input
          className="form-control login-input input-password-bar"
          type="password"
          name="password"
          id="password"
          data-testid="password"
          ref={passwordRef}
          onChange={handlePwdInput}
        />
        <label
          htmlFor="confirmPassword"
          className="login-label"
        >
          Confirm Password
        </label>
        <input
          className="form-control login-input input-password-bar"
          type="password"
          name="confirmPassword"
          ref={confirmPasswordRef}
          id="confirmPassword"
          data-testid="confirmPassword"
          onChange={handleConfirmPwdInput}
        />
        {updatePwdError && <p className="error">{updatePwdError}</p>}
        <button
          className={isUpdatePwdBtnEnabled() ? 'primary-btn' : 'disabled-btn'}
          onClick={handleUpdatePwd}
          disabled={!isUpdatePwdBtnEnabled()}
        >
          Update Password
        </button>
      </div>
      <hr />
    </>
  )
}

export default UpdatePassword
